var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 67.27 67.79",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.65 33.98c0-0.64 0-1.27-0.1-1.9l7.22-3.94-2.86-7.71-7.59 1.41a24.73 24.73 0 0 0-2.45-3.45l3.53-7.43-6.85-4.56-5.31 5.6a23.54 23.54 0 0 0-4.16-1.36l-1.51-8.14-8.22 0.32-1 7.8a22.32 22.32 0 0 0-4.7 1.63h-0.1l-5.78-5.25-6.34 5.23 3.73 6.56a24.67 24.67 0 0 0-1.83 2.59l-8.26-1.07-2.25 7.91 7 3.37a23.61 23.61 0 0 0-0.12 2.39c0 0.63 0 1.25 0.09 1.87l-7.29 4 2.86 7.71 7.66-1.43a24.09 24.09 0 0 0 2.41 3.41l-3.56 7.48 6.85 4.56 5.35-5.67a24 24 0 0 0 3.75 1.27l1.5 8.11 8.22-0.32 1-7.53a23.67 23.67 0 0 0 4.19-1.29l6.44 5.85 6.35-5.23-3.87-6.86a24.44 24.44 0 0 0 2.47-3.32l8.16 1.09 2.25-7.92-6.99-3.35c0.11-0.8 0.11-1.61 0.11-2.43z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.65,
    cy: 33.91,
    r: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.8699d9d2.svg";
export { ForwardRef as ReactComponent };